import { MultiSelectDropdown } from "@visiblethread/react-components";
import clsx from "clsx";
import { arrayOf, bool, func, string } from "prop-types";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgencies } from "slices/opportunity/agencies/actions";
import {
  selectAgencies,
  selectAgenciesLoaded,
  selectAgenciesLoading,
} from "slices/opportunity/agencies/selectors";

import classes from "./AgencyDropdown.module.scss";

const ensureIsArray = (value) =>
  Array.isArray(value) ? value : value ? [value] : [];

const getPlaceholderText = (isLoading, isLoaded, agencies) =>
  isLoading
    ? "Loading agencies..."
    : isLoaded && agencies.length === 0
      ? "No agencies available"
      : "Select Agency(s)";

const AgencyDropdown = ({
  onChange,
  value,
  labelClassName,
  singleOption = false,
}) => {
  const dispatch = useDispatch();
  const agencies = useSelector(selectAgencies);
  const isLoading = useSelector(selectAgenciesLoading);
  const isLoaded = useSelector(selectAgenciesLoaded);

  const normalizedValue = ensureIsArray(value);
  const isEmpty = normalizedValue.length === 0;

  const handleChange = (selectedValues) => {
    const normalizedSelectedValues = ensureIsArray(selectedValues);
    onChange(normalizedSelectedValues);
  };

  const options = useMemo(
    () =>
      agencies.map((agency) => ({
        value: agency?.name || "",
        label: agency?.name || "",
      })),
    [agencies]
  );

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchAgencies());
    }
  }, [dispatch, isLoaded, isLoading]);

  return (
    <div className={classes.agency_dropdown}>
      <div className={clsx(classes.agency_dropdown__label, labelClassName)}>
        Agency
      </div>

      <div
        className={clsx(classes.agency_dropdown__select, {
          [classes.agency_dropdown__selectEmpty]: isEmpty,
        })}
      >
        <MultiSelectDropdown
          options={options}
          onSelect={handleChange}
          placeholder={getPlaceholderText(isLoading, isLoaded, agencies)}
          searchable
          values={normalizedValue}
          singleOption={singleOption}
        />
      </div>
    </div>
  );
};

AgencyDropdown.propTypes = {
  onChange: func,
  value: arrayOf(string),
  labelClassName: string,
  singleOption: bool,
};

export default AgencyDropdown;
